import { useEffect, useRef, useState } from "react";

/**
 * Adds a "reveal" + "isVisible" class combo to an element once it
 * scrolls into view. Attach the returned ref to any element and
 * spread the returned className onto it (or combine with your own).
 */
export default function useReveal(options = {}) {
  const ref = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const node = ref.current;
    if (!node) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.unobserve(node);
        }
      },
      { threshold: 0.15, ...options }
    );

    observer.observe(node);
    return () => observer.disconnect();
  }, [options]);

  return { ref, isVisible };
}
